
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2216',
  depVersions: {
  "customer-portal-app": "static-1.2216",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9645",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25285",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5567",
  "hs-test-utils": "static-1.7987",
  "hub-http": "static-1.6195",
  "hub-http-shared-msw-handlers": "static-1.9888",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18158",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11438",
  "I18n": "static-7.1616",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6440",
  "payment-link-components": "static-1.23449",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6989",
  "quartz-core": "static-1.6208",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10183",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5321",
  "rich-text-lib": "static-1.19777",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17945",
  "ui-components-test-utils": "static-1.5576",
  "UIComponents": "static-3.8385",
  "foundations-assets": "static-1.4836",
  "foundations-components": "static-1.7870",
  "foundations-theming": "static-1.4391",
  "foundations-theming-specialty": "static-1.2107",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.853",
  "quartz-config": "static-1.767",
  "quartz-routing": "static-1.419",
  "quick-fetch": "static-1.3893",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16642",
  "rpc-client-utils": "static-1.4625",
  "sanitize-text": "static-1.8115",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4741",
  "ui-addon-react-router-dom": "static-1.9517",
  "usage-tracker": "static-1.7317",
  "usage-tracker-anonymous": "static-1.5734",
  "usage-tracker-core": "static-1.7167",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3380",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3266",
  "quartz-webpack": "static-1.3213",
  "bend-plugin-quartz-routing": "static-1.67",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7635",
  "frontend-preferences-client": "static-1.7902",
  "laboratory-lib": "static-3.7132",
  "onboarding-scopes": "static-1.6435",
  "ui-addon-opt": "static-4.8343",
  "HeadJS": "static-2.747",
  "hs-test-utils-bend-plugin": "static-1.3098",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.62",
  "ts-schema": "static-1.4055",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7705",
  "cssUtils": "static-1.784",
  "customer-data-ui-utilities": "static-1.9799",
  "HubStyle": "static-2.11746",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.664",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9860",
  "ui-addon-i18n": "static-1.11123",
  "ui-business-units-lib": "static-1.9022",
  "ui-shepherd-react": "static-3.10127",
  "video-components-external": "static-1.11171",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4299",
  "commerce-tours-lib": "static-1.6036",
  "customer-data-properties": "static-1.51439",
  "getting-started-shared-tasks": "static-1.18418",
  "growth-onboarding-reliability": "static-1.5056",
  "onboarding-tours": "static-1.16541",
  "reference-resolvers-lite": "static-1.8068",
  "sales-checkout-service-client": "static-1.3612",
  "ui-addon-iframeable": "static-1.9030",
  "user-context": "static-1.5075",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.829",
  "hubspotter-http": "static-1.4629",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.522",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.664",
  "quartz-head": "static-1.654",
  "quartz-test": "static-1.664",
  "quartz-tracking": "static-1.368",
  "ui-fonts": "static-1.700",
  "usage-tracker-container": "static-1.7307",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9401",
  "data-token-picker": "static-1.16353",
  "FileManagerLib": "static-1.39174",
  "property-translator": "static-1.5374",
  "atom": "static-1.5044",
  "merchandise-lib": "static-1.263",
  "purchase-motions-components": "static-1.5830",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5353",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1144",
  "bend-plugin-foundations-components": "static-1.4139",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.14",
  "trellis-assets": "static-1.1774",
  "bend-plugin-foundations-theming": "static-1.2874",
  "foundations-theming-base": "static-1.3376",
  "stylex": "static-1.32",
  "interframe": "static-3.4733",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5731",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.35",
  "chirp-fetch": "static-1.1860",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4448",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3160",
  "inbound-db-properties-service-client": "static-1.3820",
  "superstore": "static-1.4738",
  "feedback-loader": "static-1.29240",
  "ai-components-ui-library": "static-1.8860",
  "ui-addon-video-player": "static-1.8673",
  "ui-coaching-tips": "static-1.28463",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4593",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2471",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8142",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4622",
  "content-media-composition-data-lib": "static-1.12159",
  "content-media-compositions": "static-2.16166",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4127",
  "magpie-lib": "static-1.5537",
  "magpie-types": "static-1.4997",
  "media-bridge-lib": "static-1.18873",
  "video-data-lib": "static-1.34829",
  "commerce-products-lib": "static-1.9442",
  "crm-message-bus": "static-1.42909",
  "growth-data-modal": "static-1.5381",
  "hubspot-apollo-client": "static-1.4850",
  "onboarding-tours-client": "static-1.4755",
  "calling-global-api": "static-1.64411",
  "calling-internal-common": "static-1.31276",
  "calling-lifecycle-internal": "static-1.65793",
  "calling-lifecycle-messages": "static-1.58087",
  "conditional-properties-service-client": "static-1.3774",
  "crm-links": "static-1.6258",
  "customer-data-objects-ui-components": "static-1.12998",
  "customer-data-properties-shared-msw-handlers": "static-1.9215",
  "customer-data-property-utils": "static-1.8058",
  "external-options-client-types": "static-1.4135",
  "file-manager-components": "static-1.23534",
  "framework-data-schema-resolvers": "static-1.6854",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.125",
  "inbound-db-meta-service-client": "static-1.3567",
  "inbounddb-objects-service-types": "static-1.4200",
  "meetings-icalendar-utils-lib": "static-1.605",
  "multi-currency-client-types": "static-1.3668",
  "object-builder-ui-client": "static-1.48633",
  "pipeline-validation-client-types": "static-1.3942",
  "property-value-citations": "static-1.2053",
  "pulse": "static-1.538",
  "smart-property-lib": "static-1.6769",
  "tiered-pricing": "static-1.1136",
  "ui-addon-form-validation": "static-1.10963",
  "growth-onboarding-confetti": "static-1.3040",
  "growth-onboarding-next-action-utils": "static-1.1833",
  "navigation-components": "static-1.17937",
  "onboarding-tours-utils": "static-1.607",
  "ui-shepherd-tracker": "static-1.7508",
  "ui-universal-auth": "static-1.8943",
  "batch-promise": "static-1.1514",
  "navigation-messaging": "static-1.7264",
  "getting-started-shared-tasks-store": "static-1.17536",
  "hubspotter-http-shared-msw-handlers": "static-1.9886",
  "usage-tracker-session-replay": "static-1.5003",
  "audio-components": "static-1.5870",
  "FileManagerCore": "static-1.39033",
  "FileManagerImages": "static-1.36685",
  "video-components": "static-1.13174",
  "foundations-components-legacy": "static-1.895",
  "purchase-motions-api": "static-1.5833",
  "self-service-api": "static-1.10218",
  "signup-constants": "static-1.18788",
  "signup-ui-url-generator": "static-2.8013",
  "trials-service-types": "static-1.3876",
  "usage-tracker-public": "static-1.7128",
  "chatspot-core": "static-1.21143",
  "ContentUtils": "static-1.68270",
  "copilot-toolkit": "static-1.11055",
  "growth-onboarding-feedback-components": "static-1.6555",
  "reactive-lib": "static-1.695",
  "simple-logging-lib": "static-1.3022",
  "commerce-permissions": "static-1.740",
  "customer-data-tracking": "static-1.6858",
  "products-iframe-lib": "static-1.7846",
  "products-ui-components-shared-msw-handlers": "static-1.10270",
  "onboarding-data-sync-lib": "static-1.1910",
  "hubspot-apollo-cache": "static-1.309",
  "calling-error-reporting": "static-1.31282",
  "shared-worker-versioning": "static-1.11011",
  "calling-usage-tracker": "static-1.6516",
  "voice-sms-access-library": "static-1.857",
  "conversations-skeleton-state": "static-1.7221",
  "location-customization-utils-lib": "static-1.9159",
  "crm-pipelines-api-client-types": "static-1.4119",
  "framework-builder-read-service-client": "static-1.3986",
  "framework-data-schema-quick-fetch": "static-1.6759",
  "persist-promise": "static-1.3671",
  "bend-plugin-pulse": "static-1.41",
  "directed-graph": "static-1.908",
  "event-emitter": "static-1.921",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.146",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9971",
  "fsm": "static-1.3704",
  "policy-lib": "static-1.6750",
  "react-tinymce": "static-1.55153",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10034",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54279",
  "tinymce-plugins": "static-1.57393",
  "tinymce-themes": "static-1.56249",
  "growth-onboarding-next-action-components": "static-1.1861",
  "user-context-client": "static-1.4585",
  "nest": "static-1.198",
  "unified-auth-core-lib": "static-1.738",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4506",
  "video-embed": "static-1.35663",
  "content-icons-ui": "static-1.2218",
  "social-insights-client-types": "static-1.22006",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4785",
  "integrations-lib": "static-1.16020",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4237",
  "InboxConnectUtils": "static-4.14728",
  "calling-orchestration-schema": "static-1.35634",
  "crm-record-cards-service-types": "static-1.3585",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4489",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.3012",
  "tinymce-data": "static-1.40364",
  "ui-addon-sales-email": "static-1.5183",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12389",
  "layout-dnd-utils": "static-1.11364",
  "react-codemirror": "static-1.10598",
  "ui-brand-identity-lib": "static-1.15141",
  "NamespacedHubStyle": "static-2.9038",
  "outpost": "static-1.4159",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13435",
  "integrations-tracking-lib": "static-1.5572",
  "native-integrations-shared-strings": "static-1.7755",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10343",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.457",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68345",
  "layout-data-lib": "static-1.9689",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2986",
  "google-sheets-integration-lib": "static-1.145",
  "microsoft-drive-integration-lib": "static-1.262",
  "advanced-menus-core": "static-1.15084",
  "advanced-menus-lib": "static-1.12030",
  "ExportDialog": "static-6.10365",
  "ui-memberships-settings-lib": "static-1.33961",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15083",
  "simple-menus-lib": "static-1.16600"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2216",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9645",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25285",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5567",
  "hs-test-utils": "/hs-test-utils/static-1.7987",
  "hub-http": "/hub-http/static-1.6195",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9888",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18158",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11438",
  "I18n": "/I18n/static-7.1616",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6440",
  "payment-link-components": "/payment-link-components/static-1.23449",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6989",
  "quartz-core": "/quartz-core/static-1.6208",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10183",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5321",
  "rich-text-lib": "/rich-text-lib/static-1.19777",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17945",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5576",
  "UIComponents": "/UIComponents/static-3.8385",
  "foundations-assets": "/foundations-assets/static-1.4836",
  "foundations-components": "/foundations-components/static-1.7870",
  "foundations-theming": "/foundations-theming/static-1.4391",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2107",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.853",
  "quartz-config": "/quartz-config/static-1.767",
  "quartz-routing": "/quartz-routing/static-1.419",
  "quick-fetch": "/quick-fetch/static-1.3893",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16642",
  "rpc-client-utils": "/rpc-client-utils/static-1.4625",
  "sanitize-text": "/sanitize-text/static-1.8115",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4741",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9517",
  "usage-tracker": "/usage-tracker/static-1.7317",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5734",
  "usage-tracker-core": "/usage-tracker-core/static-1.7167",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3380",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3266",
  "quartz-webpack": "/quartz-webpack/static-1.3213",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.67",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7635",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7902",
  "laboratory-lib": "/laboratory-lib/static-3.7132",
  "onboarding-scopes": "/onboarding-scopes/static-1.6435",
  "ui-addon-opt": "/ui-addon-opt/static-4.8343",
  "HeadJS": "/HeadJS/static-2.747",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3098",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.62",
  "ts-schema": "/ts-schema/static-1.4055",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7705",
  "cssUtils": "/cssUtils/static-1.784",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9799",
  "HubStyle": "/HubStyle/static-2.11746",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.664",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9860",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11123",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9022",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10127",
  "video-components-external": "/video-components-external/static-1.11171",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4299",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6036",
  "customer-data-properties": "/customer-data-properties/static-1.51439",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18418",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5056",
  "onboarding-tours": "/onboarding-tours/static-1.16541",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8068",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3612",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9030",
  "user-context": "/user-context/static-1.5075",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.829",
  "hubspotter-http": "/hubspotter-http/static-1.4629",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.522",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.664",
  "quartz-head": "/quartz-head/static-1.654",
  "quartz-test": "/quartz-test/static-1.664",
  "quartz-tracking": "/quartz-tracking/static-1.368",
  "ui-fonts": "/ui-fonts/static-1.700",
  "usage-tracker-container": "/usage-tracker-container/static-1.7307",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9401",
  "data-token-picker": "/data-token-picker/static-1.16353",
  "FileManagerLib": "/FileManagerLib/static-1.39174",
  "property-translator": "/property-translator/static-1.5374",
  "atom": "/atom/static-1.5044",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "purchase-motions-components": "/purchase-motions-components/static-1.5830",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5353",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1144",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4139",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.14",
  "trellis-assets": "/trellis-assets/static-1.1774",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2874",
  "foundations-theming-base": "/foundations-theming-base/static-1.3376",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4733",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5731",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.35",
  "chirp-fetch": "/chirp-fetch/static-1.1860",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4448",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3820",
  "superstore": "/superstore/static-1.4738",
  "feedback-loader": "/feedback-loader/static-1.29240",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8860",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8673",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28463",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4593",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2471",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8142",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4622",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12159",
  "content-media-compositions": "/content-media-compositions/static-2.16166",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4127",
  "magpie-lib": "/magpie-lib/static-1.5537",
  "magpie-types": "/magpie-types/static-1.4997",
  "media-bridge-lib": "/media-bridge-lib/static-1.18873",
  "video-data-lib": "/video-data-lib/static-1.34829",
  "commerce-products-lib": "/commerce-products-lib/static-1.9442",
  "crm-message-bus": "/crm-message-bus/static-1.42909",
  "growth-data-modal": "/growth-data-modal/static-1.5381",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4850",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4755",
  "calling-global-api": "/calling-global-api/static-1.64411",
  "calling-internal-common": "/calling-internal-common/static-1.31276",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65793",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58087",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3774",
  "crm-links": "/crm-links/static-1.6258",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12998",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9215",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8058",
  "external-options-client-types": "/external-options-client-types/static-1.4135",
  "file-manager-components": "/file-manager-components/static-1.23534",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6854",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.125",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3567",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4200",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.605",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3668",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48633",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3942",
  "property-value-citations": "/property-value-citations/static-1.2053",
  "pulse": "/pulse/static-1.538",
  "smart-property-lib": "/smart-property-lib/static-1.6769",
  "tiered-pricing": "/tiered-pricing/static-1.1136",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10963",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3040",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1833",
  "navigation-components": "/navigation-components/static-1.17937",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.607",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7508",
  "ui-universal-auth": "/ui-universal-auth/static-1.8943",
  "batch-promise": "/batch-promise/static-1.1514",
  "navigation-messaging": "/navigation-messaging/static-1.7264",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17536",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9886",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5003",
  "audio-components": "/audio-components/static-1.5870",
  "FileManagerCore": "/FileManagerCore/static-1.39033",
  "FileManagerImages": "/FileManagerImages/static-1.36685",
  "video-components": "/video-components/static-1.13174",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.895",
  "purchase-motions-api": "/purchase-motions-api/static-1.5833",
  "self-service-api": "/self-service-api/static-1.10218",
  "signup-constants": "/signup-constants/static-1.18788",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8013",
  "trials-service-types": "/trials-service-types/static-1.3876",
  "usage-tracker-public": "/usage-tracker-public/static-1.7128",
  "chatspot-core": "/chatspot-core/static-1.21143",
  "ContentUtils": "/ContentUtils/static-1.68270",
  "copilot-toolkit": "/copilot-toolkit/static-1.11055",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6555",
  "reactive-lib": "/reactive-lib/static-1.695",
  "simple-logging-lib": "/simple-logging-lib/static-1.3022",
  "commerce-permissions": "/commerce-permissions/static-1.740",
  "customer-data-tracking": "/customer-data-tracking/static-1.6858",
  "products-iframe-lib": "/products-iframe-lib/static-1.7846",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10270",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1910",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.309",
  "calling-error-reporting": "/calling-error-reporting/static-1.31282",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11011",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6516",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.857",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7221",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9159",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4119",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3986",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6759",
  "persist-promise": "/persist-promise/static-1.3671",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.41",
  "directed-graph": "/directed-graph/static-1.908",
  "event-emitter": "/event-emitter/static-1.921",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.146",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9971",
  "fsm": "/fsm/static-1.3704",
  "policy-lib": "/policy-lib/static-1.6750",
  "react-tinymce": "/react-tinymce/static-1.55153",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10034",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54279",
  "tinymce-plugins": "/tinymce-plugins/static-1.57393",
  "tinymce-themes": "/tinymce-themes/static-1.56249",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1861",
  "user-context-client": "/user-context-client/static-1.4585",
  "nest": "/nest/static-1.198",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.738",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4506",
  "video-embed": "/video-embed/static-1.35663",
  "content-icons-ui": "/content-icons-ui/static-1.2218",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4785",
  "integrations-lib": "/integrations-lib/static-1.16020",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4237",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14728",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35634",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3585",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4489",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.3012",
  "tinymce-data": "/tinymce-data/static-1.40364",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5183",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12389",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11364",
  "react-codemirror": "/react-codemirror/static-1.10598",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15141",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9038",
  "outpost": "/outpost/static-1.4159",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13435",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5572",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7755",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10343",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.457",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68345",
  "layout-data-lib": "/layout-data-lib/static-1.9689",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2986",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.145",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.262",
  "advanced-menus-core": "/advanced-menus-core/static-1.15084",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12030",
  "ExportDialog": "/ExportDialog/static-6.10365",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33961",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15083",
  "simple-menus-lib": "/simple-menus-lib/static-1.16600"
}
};
